/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum QuoteTestExecutionCommentType {
  Note = "note",
  Doubts = "doubts",
  Problem = "problem",
  Important = "important",
}

export function instanceOfQuoteTestExecutionCommentType(value: any): boolean {
  for (const key in QuoteTestExecutionCommentType) {
    if (
      Object.prototype.hasOwnProperty.call(QuoteTestExecutionCommentType, key)
    ) {
      if (
        QuoteTestExecutionCommentType[
          key as keyof typeof QuoteTestExecutionCommentType
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function QuoteTestExecutionCommentTypeFromJSON(
  json: any,
): QuoteTestExecutionCommentType {
  return QuoteTestExecutionCommentTypeFromJSONTyped(json, false);
}

export function QuoteTestExecutionCommentTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteTestExecutionCommentType {
  return json as QuoteTestExecutionCommentType;
}

export function QuoteTestExecutionCommentTypeToJSON(
  value?: QuoteTestExecutionCommentType | null,
): any {
  return value as any;
}

export function QuoteTestExecutionCommentTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): QuoteTestExecutionCommentType {
  return value as QuoteTestExecutionCommentType;
}
